<template>
  <div class="login-wrapper">
    <el-card class="login-box result-card">
      <div class="icon-wrapper">
        <svg class="icon success-anim" aria-hidden="true">
          <use xlink:href="#icon-chenggong"></use>
        </svg>
      </div>

      <div class="result-header">
        <h2 class="accountinfo">邮件已发送</h2>
        <p class="email-display">账号：{{ email || this.$store.state.account }}</p>
      </div>

      <div class="notice-box">
        <p class="main-notice">
          请在 <span class="highlight">10分钟内</span> 登录邮箱查看更改密码邮件。
        </p>
        <p class="sub-notice">
          点击邮件中的链接即可重置密码。若未在收件箱找到，请检查垃圾箱，或确认邮箱填写是否正确。
        </p>
      </div>

      <div class="action-area">
        <el-button type="primary" class="back-btn" @click="background">返回登录页面</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
// 根据你的项目结构确认引用路径
import "../../assets/fonts/iconfont.js";

export default {
  data() {
    return {
      email: ""
    }
  },
  created() {
    // 尝试从 sessionStorage 获取重置密码时存入的标识
    this.email = window.sessionStorage.getItem("forget") || "";
  },
  methods: {
    background() {
      this.$router.push('/login')
    }
  }
};
</script>

<style lang="less" scoped>
/* 全屏背景容器 */
.login-wrapper {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
  box-sizing: border-box;
}

/* 白色卡片容器 */
.login-box {
  width: 420px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  border: none;
  padding: 10px;
  text-align: center;
}

/* 图标处理 */
.icon-wrapper {
  margin-top: 20px;
  .icon {
    width: 80px;
    height: 80px;
    fill: #67c23a; /* Element UI 成功绿 */
    margin: 0 auto;
    display: block;
  }
}

/* 文本信息区 */
.result-header {
  margin: 20px 0;
  .accountinfo {
    font-size: 24px;
    color: #303133;
    margin-bottom: 8px;
    font-weight: 600;
  }
  .email-display {
    font-size: 15px;
    color: #606266;
    word-break: break-all;
  }
}

/* 提示框样式 */
.notice-box {
  background-color: #f0f9eb; /* 清爽的浅绿背景 */
  border: 1px solid #e1f3d8;
  border-radius: 8px;
  padding: 18px;
  margin: 24px 0;
  text-align: left;
  
  .main-notice {
    color: #67c23a;
    font-weight: bold;
    margin-bottom: 8px;
    font-size: 14px;
    .highlight {
      color: #f56c6c; /* 强调时间限制 */
      text-decoration: underline;
    }
  }
  .sub-notice {
    color: #909399;
    font-size: 13px;
    line-height: 1.6;
  }
}

/* 底部按钮 */
.action-area {
  margin-bottom: 10px;
  .back-btn {
    width: 100%;
    height: 42px;
    font-size: 16px;
    border-radius: 8px;
    letter-spacing: 1px;
  }
}

/* 移动端适配 */
@media screen and (max-width: 575px) {
  .login-wrapper {
    background: #ffffff;
    align-items: flex-start;
    padding-top: 15vh;
  }
  .login-box {
    width: 100%;
    box-shadow: none;
  }
}
</style>